import React from "react"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
dayjs.extend(advancedFormat)

interface TimeCellProps {
  /**
   * Time Stamp
   * ISO String in most cases eg. "2020-04-21T06:06:40.509Z"
   */
  timeStamp: Date
}

const TimeCell = ({ timeStamp }: TimeCellProps) => {
  return (
    <>
      <div>{dayjs(timeStamp).format("Do MMM YYYY")}</div>
      <div className="vt-muted text-xs">
        @{dayjs(timeStamp).format("h:mm A")}
      </div>
    </>
  )
}

export default TimeCell
